var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dui-popover",class:{ 'open': _vm.vm.isOpen }},[_c('div',{ref:"trigger",staticClass:"trigger",on:{"click":_vm.toggleOpen}},[_vm._t("trigger")],2),_vm._v(" "),_c('div',{staticClass:"content-container",style:({ width: _vm.contentWidth + 'px' })},[_c('div',{staticClass:"content"},[_vm._t("content")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }